import React from 'react';

import { MCButton, TextField, OtpField } from 'src/components/basic';
import AlertManager from 'src/components/alert';
import BaseComponent from 'src/components/BaseComponent';

import { formatDuration, lang, remCss } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

const intervalId = 'SecurityEmail';

class Phone extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  sendOTP = (e) => {
    e.preventDefault();
    if (
      model.state.user?.phoneNumberVerified &&
      model.state.user.phoneNumber === model.state.phoneNumber
    )
      return;

    model.sendOTP((error, res) => {
      if (res?.ok) {
        AlertManager.popup(AlertManager.TYPES.INFO, {
          title: LANG_CONST.notice.sent_sms,
          width: 450,
          actionButton: {
            label: LANG_CONST.buttons.ok,
            action: (props) => props.hide()
          }
        });
        model.setState({ showVerified: true });
      } else if (res?.expired) {
        model.setState({ resetPhoneExpired: res.expired, showVerified: false });
        this.timer(() => model.state.resetPhoneExpired > Date.now(), intervalId);
      }
    });
  };

  verifyOTP = (e) => {
    e.preventDefault();
    model.verifyOTP((error, res) => {
      if (res?.ok) {
        model.handleChange('code', '');
        AlertManager.popup(AlertManager.TYPES.INFO, {
          title: LANG_CONST.notice.successfully_verified_phone,
          width: 420,
          actionButton: {
            label: LANG_CONST.buttons.ok,
            action: (props) => props.hide()
          }
        });
        this.cancel(e);
      } else if (res?.expired) {
        model.setState({ resetPhoneExpired: res.expired });
        this.timer(() => model.state.resetPhoneExpired > Date.now(), intervalId);
      }
    });
  };

  cancel = (e) => {
    e.preventDefault();
    model.resetApiState('verifyOTP');
    model.resetApiState('sendOTP');
    model.setState({
      phoneNumber: model.state.user.phoneNumber,
      resetPhoneExpired: 0,
      showVerified: false
    });
  };

  render() {
    const { handleChange, handleBlur } = model;
    const createState = model.getApiState('sendOTP');
    const { invalid, loading } = createState;

    if (invalid.value) {
      invalid['phoneNumber'] = invalid.value;
    }

    if (createState.error === 'PHONENUMBER_TAKEN') {
      invalid['phoneNumber'] = createState.errorMessage;
      createState.error = '';
    }
    if (createState.error === 'BLOCKED') createState.errorMessage = '';

    const createStateVerifyOtp = model.getApiState('verifyOTP');
    if (createStateVerifyOtp.error === 'INVALID_CODE') {
      createStateVerifyOtp.invalid['code'] = createStateVerifyOtp.errorMessage;
    }
    if (createStateVerifyOtp.error === 'BLOCKED') createStateVerifyOtp.errorMessage = '';

    const { blocked, expiredIn } = model.getBlock(model.state.resetPhoneExpired);

    let blockedInMin = Math.ceil(expiredIn / 60);
    blockedInMin = `${blockedInMin} ${blockedInMin > 2 ? 'minutes' : 'minute'}`;

    const phoneUnverified =
      !model.state.user?.phoneNumberVerified ||
      model.state.user.phoneNumber !== model.state.phoneNumber;

    return (
      <form className={'mc-setting-change-pw'} onSubmit={this.sendOTP}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t(LANG_CONST.change_phone_number)}</div>
        </div>
        <div className={'mc-form'}>
          <div className={'mc-flex-25-col mc-mlr30'}>
            <div className={'mc-flex-20 mc-flex-start'}>
              <div className={'mc-grow'}>
                <TextField
                  template={6}
                  defaultCountryName={model.state.tempCountryAddress}
                  name={'phoneNumber'}
                  type='phone'
                  value={model.input('phoneNumber').toString()}
                  onChange={(n, v) => {
                    model.resetApiState('sendOTP');
                    model.resetApiState('verifyOTP');
                    model.setStateSilent({ resetPhoneExpired: 0 });
                    handleChange(n, v);
                    setTimeout(() => {
                      const showBtn =
                        !model.state.user?.phoneNumberVerified ||
                        model.state.user.phoneNumber !== model.state.phoneNumber;
                      if (showBtn) {
                        document.getElementById('security_phone_footer')?.scrollIntoView();
                      }
                    }, 100);
                  }}
                  onBlur={handleBlur}
                  label={LANG_CONST.phone_number}
                  invalid={invalid}
                />
              </div>
              <div className={'mc-grow mc-flex-10'} style={{ marginTop: remCss(37) }}>
                <MCButton
                  medium
                  primary={!phoneUnverified}
                  secondary={phoneUnverified}
                  light
                  label={lang.t(!phoneUnverified ? LANG_CONST.verified : LANG_CONST.not_verified)}
                />
              </div>
            </div>
            {model.state?.showVerified && (
              <div className={'mc-flex-20 mc-flex-start'}>
                <div className={'mc-grow'}>
                  <OtpField
                    template={6}
                    name={'code'}
                    type='opt'
                    inputType={'tel'}
                    value={model.input('code').toString()}
                    numInputs={model.state.codeLength}
                    onChange={(n, v) => {
                      model.resetApiState('sendOTP');
                      model.resetApiState('verifyOTP');
                      model.setStateSilent({ resetPhoneExpired: 0 });
                      handleChange(n, v);
                    }}
                    label={LANG_CONST.verification_code}
                    invalid={createStateVerifyOtp.invalid}
                  />
                </div>
                <div className={'mc-grow mc-flex-10'} style={{ marginTop: remCss(37) }}>
                  <MCButton
                    medium
                    type={'button'}
                    onClick={this.verifyOTP}
                    disabled={blocked || createStateVerifyOtp.loading}
                    loading={createStateVerifyOtp.loading}
                    primary
                    dark={!blocked}
                    light={blocked}
                    label={
                      blocked
                        ? lang.t(LANG_CONST.buttons.verify_in, {
                            duration: formatDuration(expiredIn)
                          })
                        : LANG_CONST.buttons.verify_number
                    }
                  />
                </div>
              </div>
            )}
            {blocked && createState.error === 'BLOCKED' && (
              <div className={'mc-label-418'}>
                {lang.t(LANG_CONST.notice.verify_code_sent_phone, { blockedInMin })}
              </div>
            )}
          </div>
        </div>
        {phoneUnverified && (
          <div className={'mc-bt mc-flex mc-p30'} id={'security_phone_footer'}>
            {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
            <div className={'mc-grow'}></div>
            {model.state.user.phoneNumber !== model.state.phoneNumber && (
              <MCButton
                onClick={this.cancel}
                medium
                primary
                radius
                light
                label={LANG_CONST.buttons.cancel}
                disabled={loading}
              />
            )}
            <MCButton
              medium
              radius
              disabled={blocked || loading}
              loading={loading}
              primary
              dark={!blocked}
              light={blocked}
              label={
                blocked
                  ? lang.t(LANG_CONST.buttons.send_verification_in, {
                      duration: formatDuration(expiredIn)
                    })
                  : lang.t(LANG_CONST.buttons.send_verification)
              }
              type={'submit'}
            />
          </div>
        )}
      </form>
    );
  }
}

export default Phone;
